import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { translator } from 'mage-i18n';
import { IconError, SpacerVertical } from '@klarna/bubble-ui';

import { Alert } from 'moet-core';

import Toggle from './Toggle';
import { ContentAnimationWrapper } from './ContentAnimationWrapper';

export const ToggleWrappedContent = ({
  t,
  toggleOnChange,
  toggleValue,
  commonContent = null,
  error = false,
  yesContent,
  noContent = null,
  noSelectionContent = null,
  yesLabel = '',
  noLabel = '',
  isDisabled = false,
}) => (
  <>
    <Toggle
      toggleOnChange={toggleOnChange}
      toggleValue={toggleValue}
      yesLabel={yesLabel}
      noLabel={noLabel}
      isDisabled={isDisabled}
    />
    {error && (
      <Alert
        type="error"
        content={t('products-fe.error_messages.validation.generic_toggle_undefined')}
        icon={IconError}
      />
    )}
    <SpacerVertical spaceToken="space/600" />
    {toggleValue === false && noContent}
    {toggleValue === true && (
      <ContentAnimationWrapper>{yesContent || null}</ContentAnimationWrapper>
    )}
    {toggleValue === undefined && noSelectionContent}
    {commonContent}
  </>
);

ToggleWrappedContent.propTypes = {
  t: PropTypes.func.isRequired,
  toggleOnChange: PropTypes.func.isRequired,
  commonContent: PropTypes.node,
  error: PropTypes.bool,
  isDisabled: PropTypes.bool,
  noContent: PropTypes.node,
  noLabel: PropTypes.string,
  noSelectionContent: PropTypes.node,
  toggleValue: PropTypes.bool,
  yesContent: PropTypes.node,
  yesLabel: PropTypes.string,
};

export default connect(state => ({ t: translator(state) }))(ToggleWrappedContent);
